import { render } from "./StandardHeaderExploreTopicsMenu.vue?vue&type=template&id=7a43e12e&scoped=true"
import script from "./StandardHeaderExploreTopicsMenu.vue?vue&type=script&lang=js"
export * from "./StandardHeaderExploreTopicsMenu.vue?vue&type=script&lang=js"

import "./StandardHeaderExploreTopicsMenu.vue?vue&type=style&index=0&id=7a43e12e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a43e12e"]])

export default __exports__